import type { RouteRecordName } from 'vue-router';

const SETTINGS_ROUTE_PREFIX = 'app.profile';

export const isSettingsRouteName = (name: RouteRecordName | null | undefined) =>
  typeof name === 'string' && name.indexOf(SETTINGS_ROUTE_PREFIX) === 0;
